export default "__VITE_ASSET__DHrn$rxk__"